import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Jumbotron
} from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import handleValidation from '../Validation';
import "./style.css";

class ContactUs extends Component {
  constructor() {
    super()
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      subject: '',
      textArea: ''
    }
  }


  submitDetails = event => {
    debugger;

    let formData = {
      first_name: this.refs.first_name.value,
      last_name: this.refs.last_name.value,
      contact: this.refs.contact.value,
      email: this.refs.email.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] === true) {
      document.getElementById("contactUs").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("contactUs").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    return (
      <div className="dark-background white  " style={{ textAlign: "left" }}>
        <Jumbotron fluid className="contact-hero ">
          <Row>
            <Col sm={{ size: 6, offset: 2 }}>
              <h1 style={{ marginTop: '6rem' }}>Contact Us</h1>
            </Col>
          </Row>
        </Jumbotron>

        <Container>
          <Row>
            <Col sm={{ size: 10, offset: 1 }}>
              <p className="mt-5">
                Thank you for reaching out!
                <br /> <br />
                If you have any questions about our courses or the company, please feel free to contact us below or email us at info@itslighthouse.com We’re happy to help!
              </p>
            </Col>
          </Row>

          <Row>
            <Col sm={{ size: 8, offset: 2 }}>
              <div style={{ padding: "2rem" }}>
                <form
                  id="contactUs"
                  action=""
                  method=""
                    onSubmit={this.submitDetails.bind(this)}
                >
                  <input type="hidden" name="lead_source" value="Website" />
                    <input type="hidden" name="oid" value="00D3i000000GUvA" />
                    <input
                      type="hidden"
                      name="00N3i00000Bm5C9"
                      value="Contact_us_website_v1"
                    />
                    <input
                      type="hidden"
                      name="retURL"
                      value="https://atlighthouse.com/thank-you"
                    />
                  <Row>
                    <Col>
                      <label htmlFor="first_name" className="apply-now-labels">
                        First Name<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="first_name"
                        maxLength="40"
                        name="first_name"
                        size="20"
                        type="text"
                        ref="first_name"
                        className="apply-now-inputs form-control"
                        placeholder="First Name"
                      />
                       {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["first_name"]}
                          </span>
                        ) : (
                          ""
                        )}
                      <br />
                    </Col>
                    <Col>
                      <label htmlFor="last_name" className="apply-now-labels">
                        Last Name<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="last_name"
                        maxLength="80"
                        name="last_name"
                        size="20"
                        type="text"
                        ref="last_name"
                        className="apply-now-inputs form-control"
                        placeholder="Last Name"
                      />
                       {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["last_name"]}
                          </span>
                        ) : (
                          ""
                        )}
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="email" className="apply-now-labels">
                        Email<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="email"
                        maxlength="80"
                        name="email"
                        size="20"
                        type="text"
                        ref="email"
                        className="apply-now-inputs form-control"
                        placeholder="Email"
                      />
                       {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["email"]}
                          </span>
                        ) : (
                          ""
                        )}
                      <br />
                    </Col>
                    <Col>
                      <label htmlFor="contact" className="apply-now-labels">
                        Phone<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="contact"
                        maxlength="40"
                        name="phone"
                        size="20"
                        type="text"
                        ref="contact"
                        className="apply-now-inputs form-control"
                        placeholder="Phone Number "
                      />
                       {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["contact"]}
                          </span>
                        ) : (
                          ""
                        )}
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label for="subject" className="apply-now-labels">
                        Subject
                      </label>
                      <input
                        id="subject"
                        maxlength="40"
                        name="subject"
                        size="20"
                        type="text"
                        className="apply-now-inputs form-control"
                        
                      />
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label className="apply-now-labels" for="exampleText">
                        Message
                      </label>
                      <textarea
                        id="00N3i00000Bklln"
                        name="00N3i00000Bklln"
                        rows="8"
                        type="text"
                        wrap="soft"
                        className="apply-now-inputs form-control"
                        placeholder="I'm reaching out for..."
                      ></textarea>
                      <br />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn btn-secondary"
                      />
                    </Col>
                  </Row>
                </form>

                <Row>
                  <Col>
                    <p className="privacy-terms1">
                      <i>
                        By providing your email, you agree to our{" "}
                        <u>
                          <Link style={{ color: "white" }} to="/privacy-policy">
                            privacy policy
                          </Link>
                        </u>{" "}
                        and{" "}
                        <u>
                          <Link
                          style={{ color: "white" }}
                            to="/terms-and-conditions"
                          >
                          terms and conditions
                          </Link>
                        </u>
                      </i>
                      .
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(ContactUs);
